// Modules
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import VelocityTransitionGroup from 'velocity-react/velocity-transition-group';
import _ from 'lodash';
import moment from 'moment';

import { PageContent } from 'components/page';
import { TableCard, CardHeader } from 'components/content-containers/cards';
import { alerts } from 'modules/alerts/actions';
import { slideClosed, slideOpen } from 'utils/transition-groups';
import EmptyPagePlaceholder from 'components/page/empty-page-placeholder';
import FlipMove from 'components/widgets/animation/flip-move';
import PurchaseCard from 'components/models/purchases/purchase-card';
import PurchaseOrder from 'services/data/purchase-order';
import PurchaseOrderForm from 'components/models/purchases/forms/purchase-order-form';
import SVG from 'components/widgets/icons/svg';
import replaceById from 'utils/replace-by-id';

import * as actions from '../store/actions';
import * as util from '../utils/load-ticket';


// Component
class TicketTasks extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object,
    updateTask: PropTypes.func,
    ticket: PropTypes.object,
    purchaseOrders: PropTypes.array,
    teams: PropTypes.array
  };

  constructor(props) {
    super(props);

    this.state = { addNewExpense: false };
    this.createPurchaseOrder = this.createPurchaseOrder.bind(this);
    this.openExpenseForm = this.openExpenseForm.bind(this);
    this.closeExpenseForm = this.closeExpenseForm.bind(this);
    this.updatePurchaseOrder = this.updatePurchaseOrder.bind(this);
  }

  openExpenseForm() {
    this.setState({ addNewExpense: true });
  }

  closeExpenseForm() {
    this.setState({ addNewExpense: false });
  }

  updatePurchaseOrder(update) {
    const { purchaseOrders } = this.props;

    actions.set({ purchaseOrders: replaceById(update, purchaseOrders, { skipMerge: true }) });
  }

  createPurchaseOrder(values) {
    const formattedValues = _.clone(values);
    delete formattedValues.company;
    formattedValues.createdBy = formattedValues.purchasedBy;
    _.remove(formattedValues.lineItems, (lineItem) => _.every(lineItem, _.isEmpty));

    return PurchaseOrder.create(formattedValues)
      .then(() => util.loadPurchaseOrders(this.props.ticket))
      .then(() => this.setState({ addNewExpense: false }))
      .catch(alerts.catchError);
  }

  render() {
    const { purchaseOrders, ticket, currentUser } = this.props;
    const { addNewExpense } = this.state;
    const hasAgreement = _.get(ticket, 'agreement.id');
    
    if (!ticket || _.isEmpty(ticket)) return null;
    if (!hasAgreement) return <EmptyPagePlaceholder src="svg/expense-bill.svg">Add an agreement to add purchases to this ticket!</EmptyPagePlaceholder>;

    const isArchived = ticket.status === 'Archived';
    const purchases = _.orderBy(purchaseOrders, [order => moment(order.date).toDate()], ['desc']);

    _.forEach(purchases, (purchaseOrder) => {
      _.set(purchaseOrder, 'update', this.updatePurchaseOrder);
    });

    return (
      <PageContent className="bg-medium-blue-grey ticket">
        { !addNewExpense && !isArchived &&
          <div onClick={this.openExpenseForm} className="full-page-add-link offset-page-padding btn-success">
            <div>
              <SVG src="svg/add.svg" className="add mr-2" />
              <span>Add Purchase Order</span>
            </div>
            <SVG src="svg/expense-bill.svg" />
          </div>
        }
        <div className="ticket-expenses">
          <VelocityTransitionGroup component="div" leave={slideClosed} enter={slideOpen}>
          { addNewExpense &&
            <TableCard className="purchase-card">
              <CardHeader>
                <span>Add Purchase Order</span>
                <SVG src="svg/close.svg" className="close" onClick={this.closeExpenseForm} />
              </CardHeader>
              <PurchaseOrderForm
                initialValues={{
                  lineItems: [{}],
                  purchasedBy: currentUser.id,
                  date: moment().toDate(),
                  company: ticket.company.id,
                  ticket: ticket.id
                }}
                form={'purchaseOrderForm-new'}
                onSubmit={this.createPurchaseOrder}
                autoFocusField={'vendor'}
              />
            </TableCard>
          }
          </VelocityTransitionGroup>
          <FlipMove>
            { !addNewExpense && _.map(purchases, (purchaseOrder) =>
              <PurchaseCard key={purchaseOrder.id} purchaseOrder={purchaseOrder} />
            )}
          </FlipMove>
        </div>
      </PageContent>
    );
  }
}

// Exports
export default connect((state) => ({
  ticket: state.tickets.ticket,
  purchaseOrders: state.tickets.purchaseOrders,
  currentUser: state.auth.currentUser,
  teams: state.pageData.teams
}))(TicketTasks);



// WEBPACK FOOTER //
// ./app/routes/ticket/sub-routes/ticket-expenses.js